import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';
import { BottomTabBar } from './BottomTabBar.js';

export function AuthenticatedLayout(): ReactNode {
  return (
    <div className="relative min-h-screen bg-bg text-text-primary">
      <div className="pb-[88px]">
        <Outlet />
      </div>
      <BottomTabBar />
    </div>
  );
}
